import Phaser from 'phaser';
import { CONFIG } from './config.js';
import { BootScene } from './scenes/BootScene.js';
import { LobbyScene } from './scenes/LobbyScene.js';
import { GameScene } from './scenes/GameScene.js';
import { Rest } from './net.js';

// Forward uncaught client errors to the server journal (rate-limited there)
// so production issues are visible via `scripts/jgolf.sh logs`.
function installErrorForwarding(): void {
  window.addEventListener('error', (e) => {
    Rest.log('error', `uncaught: ${e.message}`, { source: `${e.filename}:${e.lineno}:${e.colno}` });
  });
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason as Error | undefined;
    Rest.log('error', `unhandledrejection: ${r?.message ?? String(e.reason)}`, { stack: r?.stack?.slice(0, 600) });
  });
}

function init(): void {
  const config: Phaser.Types.Core.GameConfig = {
    type: Phaser.AUTO,
    parent: 'game-container',
    width: CONFIG.GAME_WIDTH,
    height: CONFIG.GAME_HEIGHT,
    backgroundColor: '#0c1b12',
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    render: {
      antialias: true,
      roundPixels: false,
    },
    input: {
      activePointers: 3,
    },
    scene: [BootScene, LobbyScene, GameScene],
  };
  const game = new Phaser.Game(config);

  // Phaser's FIT mode listens to window resize/orientation events, but mobile
  // browsers don't always fire them for rotation or URL-bar collapse. Watching
  // the container guarantees the canvas re-fits whenever its box changes.
  const container = document.getElementById('game-container');
  if (container && 'ResizeObserver' in window) {
    new ResizeObserver(() => game.scale.refresh()).observe(container);
  }

  // Safety net: the lobby normally retires the splash when it mounts, but make
  // sure it can never get stuck on screen if startup is slow or errors.
  window.setTimeout(() => {
    const splash = document.getElementById('splash');
    if (splash && !splash.classList.contains('hide')) {
      splash.classList.add('hide');
      window.setTimeout(() => splash.remove(), 600);
    }
  }, 7000);
}

installErrorForwarding();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
